import { useBookingTradeSummaryQuery } from "~/generated/graphql"

export const BookingGradeRemaining = ({
  tradeId,
  gradeId,
}: {
  tradeId: number
  gradeId?: number
}) => {
  const [{ data }] = useBookingTradeSummaryQuery({
    variables: { id: tradeId },
    requestPolicy: "network-only",
  })

  const grades =
    data?.trade_grade_quantity_summary_report?.grade_summary?.filter(
      g => g?.variety_grade_id
    ) || []

  if (gradeId) {
    const grade = grades.find(g => g?.variety_grade_id === gradeId)
    if (!grade?.remaining_quantity && grade?.remaining_quantity !== 0)
      return <span>--</span>
    return <span>{grade?.remaining_quantity} Units</span>
  }

  if (!grades.length) {
    return <span>--</span>
  }

  return (
    <div className="flex flex-col gap-1">
      {grades.map(g => (
        <span key={g?.variety_grade_id} className="whitespace-nowrap">
          {g?.variety_grade_name}: {g?.remaining_quantity} Units
        </span>
      ))}
    </div>
  )
}
